import type { TranslationSchema } from '../pt-BR';
import type { DeepPartialStrings } from '../types';

export const widgets = {
    quickActions: {
        title: 'Quick add',
        newTransaction: 'New transaction',
        tapToAdd: 'Tap to add',
        expense: 'Expense',
        income: 'Income',
        transfer: 'Transfer',
        card: 'Card',
    },
    balance: {
        balance: 'Balance',
        monthBalance: '{{month}} balance',
        income: 'Income',
        expense: 'Expenses',
        lockedCta: 'Tap to unlock',
        error: 'Open Kontto to refresh',
    },
    common: {
        openApp: 'Tap to open Kontto',
    },
    invoice: {
        currentInvoice: 'Current bill',
        sampleCard: 'Card',
        available: 'Available {{value}}',
        ofLimit: '{{percent}}% of limit',
        limit: 'Limit {{value}}',
        empty: 'No credit card added',
    },
    bills: {
        titleSmall: 'To pay',
        title: 'Upcoming bills',
        dueToday: 'Due today',
        monthTotal: '{{value}} this month',
        more_one: '+{{count}} bill · {{value}}',
        more_other: '+{{count}} bills · {{value}}',
        empty: 'Nothing due until the end of the month',
    },
    budgets: {
        titleSmall: 'Budget',
        title: 'Budgets',
        usedOfTotal: 'of total used',
        totalOf: '{{spent}} of {{limit}}',
        daysLeft_one: '{{count}} day left',
        daysLeft_other: '{{count}} days left',
        empty: 'No budgets created',
    },
    config: {
        title: 'Widget appearance',
        cardTitle: 'Card to show',
        subtitle: 'Choose the background for this widget.',
        options: {
            brand: 'Kontto (gradient)',
            auto: 'Automatic (follows system)',
            light: 'Light',
            dark: 'Dark',
        },
        save: 'Save',
        cancel: 'Cancel',
    },
} satisfies DeepPartialStrings<TranslationSchema['widgets']>;
